/**
 * 数値か判定して100倍し、%を付与して返却する
 */
export const parsePercentage = (num: unknown, symbol: string = '%') => {
  return /\d+/.test(num as string) ? `${Number(num) * 100}${symbol}` : '';
};
